<script lang="ts" setup name="G2oTourTarget">
const { animated = true } = defineProps<{
  animated?: boolean;
}>();
</script>

<template>
  <div
    class="flex h-09 w-09 items-center justify-center rounded-full bg-black bg-opacity-25"
    :class="{ 'transition-all': animated }"
  >
    <div
      v-if="animated"
      class="absolute h-6 w-6 animate-ping rounded-full bg-secondary-3"
    />
    <div class="h-6 w-6 rounded-full bg-secondary-3" />
  </div>
</template>
